import { z } from "zod";

export const SyncMyAuthEmailToInternalPostBodySchema = z.null();
export type SyncMyAuthEmailToInternalPostBody = z.infer<typeof SyncMyAuthEmailToInternalPostBodySchema>;

export const SyncMyAuthEmailToInternalResponseSchema = z.object({
  userEmail: z.email().optional(),
  createdInternal: z.boolean(),
  updatedInternal: z.boolean(),
});
export type SyncMyAuthEmailToInternalResponse = z.infer<typeof SyncMyAuthEmailToInternalResponseSchema>;
